import { getFavoriteCount } from "@src/utils/favorite";

const countElement = document.querySelector(
  '.container-header-nav-item[data-name="shortlist"] [data-count]'
);

export default function updateHeaderShortlistCount() {
  if (countElement) {
    const count = getFavoriteCount().toString();
    countElement.setAttribute("data-count", count);
    countElement.innerHTML = count;
  }
}
